import gql from 'graphql-tag';
import AuthUserFragment from 'containers/Auth/graphql/userFragment.gql';
import WRAPPER_QUERY from 'containers/LegacyCartPage/graphql/ordersWrapperQuery.gql';
import CART_QUERY from 'containers/LegacyCartPage/graphql/legacyCartQuery.gql';
import { GOOGLE_APP_ID, AUTH_TOKEN, GUEST_TOKEN } from 'config/constants';
import { reportRegisterationAnalytics } from 'containers/Auth/Helpers/actions';
import apolloClient from '../apolloClient';

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;

const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;

const USER_QUERY = gql`
  query User {
    user {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;

const SOCIAL_AUTH_MUTATION = gql`
  mutation socialAuth(
    $access_token: String!
    $expires_at: BigInt!
    $provider: String!
    $country_iso_code: String!
  ) {
    socialAuth(
      access_token: $access_token
      expires_at: $expires_at
      provider: $provider
      country_iso_code: $country_iso_code
    ) {
      id
      token
      first_auth_signup
      first_signup_type
    }
  }
`;

const UPDATE_FIRST_SIGNUP = gql`
  mutation updateFirstSignup($isNewMember: Boolean!) {
    updateFirstSignup(isNewMember: $isNewMember) @client
  }
`;

const COUNTRY_CODE_QUERY = gql`
  query CountryCode {
    geo {
      countryCode
    }
  }
`;

const {
  geo: { countryCode },
} = apolloClient.readQuery({
  query: COUNTRY_CODE_QUERY,
});

const isToken = !!localStorage.getItem(AUTH_TOKEN);
window.isLoggedIn = isToken;

const updateFirstSignupMutation = (isNewMember) =>
  apolloClient.mutate({
    mutation: UPDATE_FIRST_SIGNUP,
    variables: { isNewMember },
  });

const socialAuthMutation = (variables) =>
  apolloClient.mutate({
    mutation: SOCIAL_AUTH_MUTATION,
    variables,
    update: (proxy, { data: { socialAuth } }) => {
      window.isLoggedIn = true;

      localStorage.setItem(AUTH_TOKEN, socialAuth.token);
      localStorage.removeItem(GUEST_TOKEN);

      window.google.accounts.id.cancel();

      proxy.writeQuery({
        query: IS_TOKEN,
        data: {
          isToken: !!socialAuth.token,
        },
      });

      proxy.writeQuery({
        query: IS_LOGGED_IN,
        data: {
          isLoggedIn: !!socialAuth.token,
        },
      });

      updateFirstSignupMutation(socialAuth.first_auth_signup);
      if (
        typeof socialAuth.first_signup_type === 'string' &&
        socialAuth.first_signup_type.length > 0
      ) {
        reportRegisterationAnalytics(socialAuth.first_signup_type);
        console.log(socialAuth.first_signup_type);
      }
    },
    refetchQueries: () => [
      { query: USER_QUERY },
      { query: CART_QUERY },
      { query: WRAPPER_QUERY },
    ],
    awaitRefetchQueries: true,
    errorPolicy: 'all',
  });

const googleResponseCallback = (response) => {
  if (response && response.credential) {
    return socialAuthMutation({
      access_token: response.credential,
      expires_at: new Date().getTime(),
      provider: 'google',
      country_iso_code: countryCode,
    });
  }

  console.log('googleResponseCallback issue', response);
};

const facebookResponseCallback = (response) => {
  console.log('facebookResponseCallback', response);

  if (response && response.authResponse) {
    return socialAuthMutation({
      access_token: response.authResponse.accessToken,
      expires_at: new Date().getTime() + response.authResponse.expiresIn,
      provider: 'facebook',
      country_iso_code: countryCode,
    });
  }

  console.log('facebookResponseCallback issue', response);
};

export const initFacebookAuth = () => {
  if (window.FB) {
    window.FB.getLoginStatus((response) => {
      if (response.authResponse) {
        window.FB.logout();
      }
    }, true);

    window.FB.Event.subscribe('auth.login', facebookResponseCallback);
    window.FB.Event.subscribe('auth.statusChange', facebookResponseCallback);
    // window.FB.getLoginStatus(facebookResponseCallback, true);

    console.log('initFacebookAuth done');
  } else {
    setTimeout(initFacebookAuth, 200);
  }
};

export const initGoogleAuth = () => {
  if (window.google) {
    window.google.accounts.id.initialize({
      client_id: GOOGLE_APP_ID,
      callback: googleResponseCallback,
      cancel_on_tap_outside: false,
      context: 'use',
    });
    console.log('initGoogleAuth done');
  } else {
    setTimeout(initGoogleAuth, 200);
  }
};

export const promptOneTap = () => {
  if (window.isLoggedIn) return;

  if (window.google && window.google.accounts) {
    try {
      window.google.accounts.id.prompt();
      console.log('promptOneTap done');
    } catch (error) {
      console.log('promptOneTap catch error', error);
      initGoogleAuth();
      promptOneTap();
    }
  } else {
    setTimeout(promptOneTap, 200);
  }
};



// WEBPACK FOOTER //
// ./app/lib/socialAuthHandler.js